<template>
  <div class="content" id="budget-controle">
    <div class="results-header">
      <div class="results-header__title">
        <h3 class="title">Budgetcontrole</h3>
      </div>
    </div>
    <div class="results-main">
      <template v-if="!isBusy">
<!--        <div class="mb-5">-->
<!--          <div class="field field&#45;&#45;button actions">-->
<!--            <div class="control">-->
<!--              <button class="button is-primary is-inverted m-0"><font-awesome-icon icon="download" class="mr-2"/> Exporteren</button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <table class="table is-fullwidth result-table" v-for="(result, key) in data" v-bind:key="key">
          <thead>
          <tr @click="openResultGroup(key)" style="cursor: pointer">
            <th colspan="8">
              {{ key }}
              <font-awesome-icon icon="caret-up" v-if="resultGroupsStatus[key]"/>
              <font-awesome-icon icon="caret-down" v-else/>
            </th>
          </tr>
          </thead>
          <template v-if="resultGroupsStatus[key]">
            <thead>
            <tr>
              <td colspan="8">
                  <span class="has-text-weight-medium">
                    Periode:
                  </span>
                  {{ result[0]['date_from'] }} - {{ result[0]['date_to'] }}
                </td>
              </tr>
              <tr class="budget-headers">
                <th style="width: 5%">Type</th>
                <th style="width: 10%">Uiterste verschijningsdatum</th>
                <th style="width: 10%">Budget&nbsp;(€)</th>
                <th style="width: 10%">Gefact.(€)</th>
                <th width="1px">Geleverd - Nog te&nbsp;factureren&nbsp;(€)&nbsp;<sup><a href="#info-a" class="info-url">a</a></sup></th>
                <th width="1px">Nog&nbsp;te&nbsp;leveren (aantal)</th>
                <th width="1px">Levering verplaatst naar volgend jaar (aantal)</th>
                <th width="1px">Te spenderen budget&nbsp;(€)</th>
              </tr>
              </thead>
              <tbody>
              <tr class="results-main__item">
                <td class="has-text-weight-medium">Budgetten boeken</td>
                <td>{{ formatDate(result[0]['last_release_date']) }}</td>
                <td>{{ formatPrice(result[0]['budget']) }}</td>
                <td>{{ formatPrice(result[0]['invoiced']) }}</td>
                <td>{{ formatPrice(result[0]['delivered']) }}</td>
                <td>{{ result[0]['to_deliver'] }}</td>
                <td>
                  <template v-if="result[0]['to_deliver_next_year']">{{ result[0]['to_deliver_next_year'] }}</template>
                  <template v-else>0</template>
                </td>
                <td>{{ formatPrice(result[0]['budget_available']) }}</td>
              </tr>
              </tbody>
              <thead>
              <tr class="budget-headers">
                <th>Type</th>
                <th>Kastklaar</th>
                <th>Budget&nbsp;(€)</th>
                <th>Gefact.(€)</th>
                <th>Verwerkt - Nog te&nbsp;factureren&nbsp;(€)&nbsp;<sup><a href="#info-b" class="info-url">b</a></sup></th>
                <th>Nog&nbsp;te&nbsp;verwerken (€)</th>
                <th></th>
                <th>Te spenderen budget&nbsp;(€)</th>
              </tr>
              </thead>
              <tbody>
              <tr class="results-main__item">
                <td class="has-text-weight-medium">Budgetten kastklaar</td>
                <td>
                  <span v-if="result[0]['kastklaar'] === 'i'">Inbegrepen</span>
                  <span v-else>Niet inbegrepen</span>
                </td>
                <td>{{ formatPrice(result[0]['budget_kastklaar']) }}</td>
                <td>{{ formatPrice(result[0]['invoiced_kastklaar']) }}</td>
                <td>{{ formatPrice(result[0]['to_invoice_kastklaar']) }}</td>
                <td>{{ formatPrice(result[0]['to_deliver_kastklaar']) }}</td>
                <td></td>
                <td>{{ formatPrice(result[0]['budget_available_kastklaar']) }}</td>
              </tr>
              </tbody>
            </template>
        </table>
        <div class="information mb-5">
          <p id="info-a">
            <em>a. Nog te factureren boeken = Geleverde pakbonnen bestellingen én goedgekeurde zichtzendingen (indien van toepassing)</em>
          </p>
          <p id="info-b">
            <em>b. Nog te factureren kastklaar = aantal geleverde boeken (op nog te factureren pakbonnen) x prijs kastklaar (incl. btw)</em>
          </p>
        </div>
      </template>
      <LoadingBlock v-else/>
      <BackButton/>
    </div>
  </div>
</template>
<script>

import {onMounted, ref} from "vue";
import {useStore} from "vuex";
import {getAPI} from "@/utils/useApi";
import BackButton from "@/app/Components/BackButton";
import LoadingBlock from "@/app/Components/LoadingBlock";

export default {
  name: 'BudgetControl',
  components: {
    LoadingBlock,
    BackButton,
  },
  data() {
    return {
      resultGroupsStatus: {},
    }
  },
  computed: {
    isBusy() {
      return this.$store.getters.getIsBusy;
    },
    budgetType() {
      return this.$route.name;
    }
  },
  methods: {
    openResultGroup(key) {
      this.resultGroupsStatus[key] = !this.resultGroupsStatus[key];
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    calcKastklaarTotal(x, y) {
      return x - y;
    },
    formatDate(dateString) {
      if (!dateString) return "/";
      let date = new Date(dateString);
      return date.toLocaleDateString();
    },
  },
  setup() {
    const data = ref([]);
    const store = useStore();

    // Fetch data
    onMounted(async () => {
      store.commit('setBusy');

      // if (process.env.NODE_ENV) {
      //   console.debug('USE MOCK DATA');
      //   let results = [ { "customer_parcel": "Bibliotheek TEST", "date_from": "2020-01-01", "date_to": "2020-12-31", "budget": 21500, "invoiced": 0, "delivered": 697.73, "to_deliver": 67, "budget_available": 19741.76, "kastklaar": "n", "budget_kastklaar": 3500, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 82.574, "to_deliver_kastklaar": 141.591, "budget_available_kastklaar": 3271.835 }, { "customer_parcel": "Bibliotheek TEST", "date_from": "2018-01-01", "date_to": "2018-12-31", "budget": 14000, "invoiced": 13171.090000000004, "delivered": 0, "to_deliver": 0, "budget_available": 828.9099999999962, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST", "date_from": "2017-01-01", "date_to": "2017-12-31", "budget": 0, "invoiced": 13558.890000000003, "delivered": 0, "to_deliver": 0, "budget_available": -13558.890000000003, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST", "date_from": "2016-01-01", "date_to": "2016-12-31", "budget": 0, "invoiced": 12632.92, "delivered": 0, "to_deliver": 0, "budget_available": -12632.92, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST", "date_from": "2015-01-01", "date_to": "2015-12-31", "budget": 0, "invoiced": 8961.670000000002, "delivered": 0, "to_deliver": 0, "budget_available": -8961.670000000002, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST -  Volwassenen non-fictie", "date_from": "2018-01-01", "date_to": "2018-12-31", "budget": 0, "invoiced": 0, "delivered": 0, "to_deliver": 0, "budget_available": 0, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST -  Volwassenen non-fictie", "date_from": "2017-01-01", "date_to": "2017-12-31", "budget": 1000, "invoiced": 891.0900000000001, "delivered": 0, "to_deliver": 0, "budget_available": 108.90999999999985, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST -  Volwassenen non-fictie", "date_from": "2016-01-01", "date_to": "2016-12-31", "budget": 200, "invoiced": 137.06, "delivered": 0, "to_deliver": 0, "budget_available": 62.94, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST -  Volwassenen non-fictie", "date_from": "2015-01-01", "date_to": "2015-12-31", "budget": 0, "invoiced": 0, "delivered": 0, "to_deliver": 0, "budget_available": 0, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON boekstart", "date_from": "2018-01-01", "date_to": "2018-12-31", "budget": 0, "invoiced": 554.91, "delivered": 0, "to_deliver": 0, "budget_available": -554.91, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON boekstart", "date_from": "2017-01-01", "date_to": "2017-12-31", "budget": 0, "invoiced": 9.71, "delivered": 0, "to_deliver": 0, "budget_available": -9.71, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON boekstart", "date_from": "2016-01-01", "date_to": "2016-12-31", "budget": 0, "invoiced": 175.08, "delivered": 0, "to_deliver": 0, "budget_available": -175.08, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON boekstart", "date_from": "2015-01-01", "date_to": "2015-12-31", "budget": 0, "invoiced": 449.3000000000002, "delivered": 0, "to_deliver": 0, "budget_available": -449.3000000000002, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON vertelplaten", "date_from": "2018-01-01", "date_to": "2018-12-31", "budget": 0, "invoiced": 0, "delivered": 0, "to_deliver": 0, "budget_available": 0, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON vertelplaten", "date_from": "2017-01-01", "date_to": "2017-12-31", "budget": 0, "invoiced": 181.18000000000004, "delivered": 0, "to_deliver": 0, "budget_available": -181.18000000000004, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON vertelplaten", "date_from": "2016-01-01", "date_to": "2016-12-31", "budget": 0, "invoiced": 59.88, "delivered": 0, "to_deliver": 0, "budget_available": -59.88, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 }, { "customer_parcel": "Bibliotheek TEST - BESTELBON vertelplaten", "date_from": "2015-01-01", "date_to": "2015-12-31", "budget": 0, "invoiced": 0, "delivered": 0, "to_deliver": 0, "budget_available": 0, "kastklaar": "n", "budget_kastklaar": 0, "invoiced_kastklaar": 0, "to_invoice_kastklaar": 0, "to_deliver_kastklaar": 0, "budget_available_kastklaar": 0 } ];
      //
      //   const groupBy = function (data, key) {
      //     return data.reduce(function (rv, x) {
      //       (rv[x[key]] = rv[x[key]] || []).push(x);
      //       return rv;
      //     }, {});
      //   };
      //
      //   data.value = groupBy(results, 'customer_parcel');
      //   store.commit('clearBusy');
      // }

      getAPI('/api/budgets')
          .then((response) => {
            let results = response.data;

            // Sort function
            const groupBy = function (data, key) {
              return data.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
              }, {});
            };

            // Sort by parcel
            data.value = groupBy(results, 'customer_parcel');

            store.commit('clearBusy');
          })
          .catch((error) => {
            // TODO Error handling
            console.log(error);
            store.commit('clearBusy');
          });
    });

    return {
      data,
    }
  }
};

</script>
<style lang="scss">
#budget-controle
{
  min-height: calc(100vh - 5rem);
  background: $darker-gray;

  .results-main
  {
    padding: 2em;

    &__item {
      cursor: default;
    }
  }

  .budget-headers {
    th {
      border-width: 1px 0;
      background: #fafafa;
      padding: 10px;
    }
  }
}

.information
{
  color: #A7A7A7;
}

.info-url
{
  color:           $black !important;
  text-decoration: underline !important;

  &:hover
  {
    color: $black;
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
}
</style>
